<div class="loading-container" *ngIf="loading">
    <kendo-loader type="converging-spinner" size="large" *ngIf="loading"></kendo-loader>
</div>
<!-- <app-reason-for-delay *ngIf="showReasonForDelayDialog" [title]="title" [evalutionSk]="evaluationSk"
    [referralsk]="referralSk" (close)="closeReasonForDelayDialog($event)" [studentDetails]="studentDetails">
</app-reason-for-delay> -->
<div *ngIf="form" class="layout">
    <div [ngClass]="createExtension === true ? 'layout2' : 'layout1'">
        <div class="shm-heading">
            <div class="k-d-inline-flex">
                <div class="section-heading margin" *ngIf="!showReviewAssessment">
                    <h2>
                        {{title}}
                    </h2>
                </div>
                <div class="section-heading  title-margin" *ngIf="showReviewAssessment">
                    Review Assessment
                </div>
            </div>
        </div>

        <form [formGroup]="form">
            <div>
                <!-- Review Extension -->
                <div class="contact-details k-my-4" *ngIf="!showReviewAssessment">
                    <div class="k-ml-2 k-mr-2 k-mb-1 k-w-full">
                        <p class="k-m-0">Evaluation Due by Date</p>
                    </div>
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <p class="k-mt-1 !k-font-semibold">
                            {{dueDate !== 'Invalid Date' ? dueDate: '' }}
                        </p>
                    </div>

                </div>

                <!-- Review Assessment -->
                <div class="contact-details k-my-4" *ngIf="showReviewAssessment">
                    <div class="k-ml-2 k-mr-2 k-mb-1 k-w-full">
                        <p class="k-m-0">Review Submitted Date</p>
                    </div>
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <p class="k-mt-1 !k-font-semibold">
                            {{date | date:"MM/dd/yyyy"}}
                        </p>
                    </div>

                </div>
                <div class="contact-details k-my-4" *ngIf="showReviewAssessment">
                    <div class="k-ml-2 k-mr-2 k-mb-1 k-w-full">
                        <p class="k-m-0">Review Submitted By</p>
                    </div>
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <p class="k-mt-1 !k-font-semibold">
                            {{reviewSubmittedDisplayName}}
                        </p>
                    </div>

                </div>

                <div class="contact-details k-my-4" *ngIf="!showReviewAssessment">
                    <div class="k-d-flex k-justify-content-stretch">
                        <div class="k-mb-1 k-mx-2 k-w-full">
                            <!-- Kendo Floating Label for Extension Days Needed -->
                            <kendo-floatinglabel text="Extension Days Needed *">
                                <kendo-dropdownlist [ngClass]="{
                                    'extension-fixed-width': createExtension,
                                    'fixed-width': !createExtension,
                                    'invalid-dropdown': showExtensionDaysError
                                }" [data]="extensionDaysRange" [rounded]="'large'" [size]="'medium'"
                                    formControlName="extensionDays"></kendo-dropdownlist>
                                <kendo-formerror *ngIf="showExtensionDaysError">
                                    Number of Days is Required.
                                </kendo-formerror>
                            </kendo-floatinglabel>
                        </div>
                        <div class="k-mb-1 k-w-full">
                            <!-- Kendo Floating Label for Requested Due By Date -->
                            <kendo-floatinglabel text="Requested Due by Date">
                                <!-- Kendo DatePicker -->
                                <kendo-datepicker calendarType="classic"
                                    [ngClass]="createExtension === true ? 'extension-fixed-width' : 'fixed-width'"
                                    rounded="large" formControlName="reviewDate" placeholder="MM/DD/YYYY"
                                    [format]="format" [readonly]="true">
                                </kendo-datepicker>
                            </kendo-floatinglabel>
                        </div>
                    </div>
                </div>

                <div class="contact-details k-my-4" *ngIf="!showReviewAssessment">
                    <div class="k-d-inline-flex">
                        <p class="k-m-0">Reason for Extension</p>
                    </div>

                    <div class="k-d-flex k-justify-content-stretch margin-top">
                        <div class=" k-mb-1  k-w-full">
                            <kendo-label text="" class="student-document__label"> </kendo-label>
                            <kendo-dropdownlist [data]="referenceData.reason" [rounded]="'large'"
                                [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                                formControlName="reason"></kendo-dropdownlist>
                        </div>
                    </div>

                </div>

                <div class="contact-details k-my-4" *ngIf="showAddInformation && !showReviewAssessment">
                    <div class="k-d-inline-flex ">
                        <p class="k-m-0">Additional Information</p>
                    </div>

                    <div class="k-d-flex k-justify-content-stretch margin-top">
                        <div class=" k-mb-1 k-w-full">
                            <kendo-label text="" class="student-document__label"> </kendo-label>
                            <kendo-formfield class="!k-mt-0" showHints="always">
                                <kendo-textarea placeholder="Type here" class="student-document__textarea" [rows]="3"
                                    resizable="vertical" [readonly]="this.action === reviewAction"
                                    formControlName="otherReason"></kendo-textarea>
                            </kendo-formfield>
                        </div>
                    </div>

                </div>

                <!-- ///Approve or Rejected -->
                <div class="approve-action k-my-4" *ngIf="showApproveOrRejectBtn">
                    <div class="k-d-flex k-justify-content-center">
                        <div class="k-w-100">
                            <kendo-buttongroup [selection]="'single'" style="width: 100%;"
                                [disabled]="this.action === viewAssessment || this.action === view">
                                <button kendoButton [toggleable]="true" (click)="getAction('Approve')"
                                    [ngClass]="{ 'button-highlight': selectedAction === 'Approve' }"
                                    class="large-button">Approve
                                </button>
                                <button kendoButton [toggleable]="true" (click)="getAction('Reject')"
                                    [ngClass]="{ 'button-highlight': selectedAction === 'Reject' }"
                                    class="large-button">Reject
                                </button>
                            </kendo-buttongroup>
                        </div>
                    </div>
                </div>

                <div class="contact-details k-my-4" *ngIf="showApproveFields  && !showReviewAssessment">
                    <div class="k-d-flex k-justify-content-stretch">
                        <div class=" k-mb-1 k-w-full">

                            <kendo-formfield>
                                <kendo-floatinglabel text="Extension Days Approved *">

                                    <kendo-numerictextbox class="k-h-9" formControlName="extensionDaysApproved"
                                        rounded="large" [min]="1" [max]="30" [decimals]="0"
                                        format="##"></kendo-numerictextbox>
                                </kendo-floatinglabel>
                                <kendo-formerror *ngIf="form.get('extensionDaysApproved')?.errors?.required">Error:
                                    Field is required</kendo-formerror>
                                <kendo-formerror
                                    *ngIf="form.get('extensionDaysApproved')?.errors?.minError || form.get('extensionDaysApproved')?.errors?.maxError">Error:
                                    Days should be between 1 to 30</kendo-formerror>
                            </kendo-formfield>
                        </div>
                    </div>
                </div>
                <div class="contact-details k-my-4" *ngIf="showApproveFields && !showReviewAssessment">
                    <div class="k-d-flex k-justify-content-stretch">
                        <div class=" k-mb-1 k-w-full">


                            <kendo-label text="New Due by Date" class="student-document__label"> </kendo-label>

                            <kendo-datepicker calendarType="classic" formControlName="newDueByDate" rounded="large"
                                placeholder="MM/DD/YYYY" [format]="format"
                                [readonly]="this.action === reviewAction"></kendo-datepicker>
                        </div>
                    </div>
                </div>

                <div class="contact-details k-my-4" *ngIf="showRejectFields && !showReviewAssessment">
                    <div class="k-d-inline-flex ">
                        <p class="k-m-0">Reason for Rejection *</p>
                    </div>

                    <div class="k-d-flex k-justify-content-stretch margin-top">
                        <div class=" k-mb-1 k-w-full">
                            <kendo-formfield>
                                <kendo-label text="" class="student-document__label"> </kendo-label>
                                <kendo-dropdownlist [data]="referenceData.reason" [rounded]="'large'"
                                    [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                                    formControlName="reasonForRejection"></kendo-dropdownlist>
                                <kendo-formerror>Error: Field is required</kendo-formerror>
                            </kendo-formfield>
                        </div>
                    </div>
                </div>


                <div class="contact-details k-my-4"
                    *ngIf="showRejectFields && showRejectedAddInformation &&  !showReviewAssessment">
                    <div class="k-d-inline-flex ">
                        <p class="k-m-0">Additional Information</p>
                    </div>

                    <div class="k-d-flex k-justify-content-stretch margin-top">
                        <div class=" k-mb-1 k-w-full">
                            <kendo-label text="" class="student-document__label"> </kendo-label>
                            <kendo-formfield class="!k-mt-0" showHints="always">
                                <kendo-textarea placeholder="Type here" class="student-document__textarea" [rows]="3"
                                    resizable="vertical" formControlName="otherReasonForRejection"></kendo-textarea>
                            </kendo-formfield>
                        </div>
                    </div>

                </div>

                <!-- Review Reject Assessment -->
                <div class="contact-details k-my-4"
                    *ngIf="showReviewAssementReject || (showReviewAssessment && this.selectedAction === reject)">
                    <div class="k-d-inline-flex ">
                        <p class="k-m-0">Reason for Rejection</p>
                    </div>

                    <div class="k-d-flex k-justify-content-stretch margin-top">
                        <div class=" k-mb-1 k-w-full">
                            <kendo-formfield>
                                <kendo-label text="" class="student-document__label"> </kendo-label>
                                <kendo-dropdownlist [data]="referenceData.reason" [rounded]="'large'"
                                    [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                                    formControlName="asstmtRejectionReason"
                                    (valueChange)="onReasonChange($event)"></kendo-dropdownlist>
                                <kendo-formerror>Error: Field is required</kendo-formerror>
                            </kendo-formfield>
                        </div>
                    </div>

                </div>

                <div class="contact-details k-my-4"
                    *ngIf="form.get('asstmtRejectionReason').value?.id === assessmentRejectionId">
                    <div class="k-d-inline-flex ">
                        <p class="k-m-0">Additional Information</p>
                    </div>

                    <div class="k-d-flex k-justify-content-stretch  margin-top">
                        <div class=" k-mb-1 k-w-full">
                            <kendo-label text="" class="student-document__label"> </kendo-label>
                            <kendo-formfield class="!k-mt-0" showHints="always">
                                <kendo-textarea placeholder="Type here" class="student-document__textarea" [rows]="3"
                                    resizable="vertical" formControlName="asstmtRejectionReasonOther"></kendo-textarea>
                            </kendo-formfield>
                        </div>
                    </div>

                </div>
            </div>

        </form>
        <div class="page-footer k-mt-2 k-text-right">
            <div class="action-btns">
                <div class="action-btns__right">

                    <button kendoButton size="medium" *ngIf="showHideCloseBtn" rounded="large" fillMode="outline"
                        themeColor="error" (click)="onCancelSHM()">
                        Close
                    </button>
                    &nbsp;
                    <button kendoButton themeColor="primary" [ngClass]="{'btn-width': !showHideCloseBtn}"
                        [disabled]="showSubmitBtn || this.form.invalid || loadSaveSpinner || (showApproveOrRejectBtn && !selectedAction) || isStatusFinalised"
                        (click)="submit()" size="medium" rounded="large" fillMode="solid">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>